import { render } from "./AuthLayout.vue?vue&type=template&id=76fc6349&scoped=true"
const script = {}

import "./AuthLayout.vue?vue&type=style&index=0&id=76fc6349&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76fc6349"]])

export default __exports__